import React from 'react';
import { motion } from 'framer-motion';
import { UserPlus, Settings, Heart, Sparkles } from 'lucide-react';

const steps = [
  {
    icon: UserPlus,
    title: 'Cadastro e Verificação',
    description: 'Crie seu perfil como Sugar Daddy, Sugar Mommy ou Sugar Baby. Verificação garante autenticidade.',
    number: '01',
  },
  {
    icon: Settings,
    title: 'Defina suas Expectativas',
    description: 'Daddies e Mommies indicam o que podem proporcionar. Babies mostram o que esperam. Clareza desde o início.',
    number: '02',
  },
  {
    icon: Heart,
    title: 'Encontre seu Match',
    description: 'Sugar Babies conectam com Daddies e Mommies que combinam com suas expectativas. Cada match é pensado.',
    number: '03',
  },
  {
    icon: Sparkles,
    title: 'Construa seu Arrangement',
    description: 'Relações baseadas em respeito mútuo, benefícios claros e experiências memoráveis.',
    number: '04',
  },
];

const HowItWorksSection = () => {
  return (
    <section id="como-funciona" className="relative py-12 md:py-32 px-4 bg-gradient-to-b from-black via-luxury-purple/5 to-black">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 md:mb-20"
        >
          <h2 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-luxury-pink via-luxury-mediumPink to-luxury-lightPurple bg-clip-text text-transparent">
            Como Funciona
          </h2>
          <p className="text-xl text-white/60 max-w-2xl mx-auto">
            Quatro passos simples para começar sua jornada no Interlaced
          </p>
        </motion.div>

        <div className="relative">
          {/* Vertical Line - Desktop Only */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-luxury-pink via-luxury-mediumPink to-luxury-lightPurple" />

          <div className="space-y-8 md:space-y-24">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`flex flex-col md:flex-row items-center gap-8 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Content Card */}
                <div className="flex-1 relative">
                  <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:border-luxury-pink/30 transition-all duration-300 group">
                    <div className="flex items-start gap-6">
                      <div className="p-4 rounded-full bg-luxury-pink/20 border border-luxury-pink/30 group-hover:scale-110 transition-transform duration-300">
                        <step.icon className="w-8 h-8 text-luxury-pink" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-2xl font-semibold text-white mb-4">
                          {step.title}
                        </h3>
                        <p className="text-white/60 leading-relaxed">
                          {step.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Number Circle - Desktop Only */}
                <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 w-16 h-16 rounded-full bg-gradient-to-br from-luxury-pink to-luxury-mediumPink items-center justify-center text-white font-bold text-xl border-4 border-black">
                  {step.number}
                </div>

                {/* Spacer for alternating layout */}
                <div className="flex-1 hidden md:block" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
